export default "__VITE_ASSET__J6hHmbFd__"